export default __webpack_public_path__ + "static/media/pdf-website.80642968.png";